import { MOBILE_SIDEBAR_TOGGLE, SIDEBAR_TOGGLE } from '../Type';

export const toggleMobileSidebar = (isMobileOpen) => {
  return {
    type: MOBILE_SIDEBAR_TOGGLE,
    data: { isMobileOpen }
  }
}

export const toggleSidebar = (isOpen) => {
  return {
    type: SIDEBAR_TOGGLE,
    data: { isOpen }
  }
}